import { Box, IconButton } from "@mui/material";
import { ActionProps } from "react-querybuilder";
import { useLanguage } from '@erpsquad/common/runtime';
import { Trash } from "../../icons";

const RemoveAction = (props: ActionProps) => {
  const { isRtl } = useLanguage();
  const btnStyles = {
    ...(isRtl ? { marginRight:-1.5 } : {}),
  }
  const iconStyles = {
    color: 'theme.grey.600',
    '&:hover': {
      color: 'theme.error.600'
    }
  }
  return (
    <Box>
      <IconButton sx={btnStyles} size={"small"} onClick={props.handleOnClick} disableRipple>
        <Trash sx={{ fontSize: '1.35rem', ...iconStyles }} />
      </IconButton>
    </Box>
  );
};

export { RemoveAction };
export default RemoveAction;
